import { Controller } from '@hotwired/stimulus';

// Injects the Google Maps Places JS SDK once per page load and re-dispatches the
// existing `google-maps-callback` event that `address-form` listens for.
// Replaces the inline <script src="…&callback=initAutocomplete"> tag we used to
// hard-code in the coupons_bd layout (project rule: no inline <script> in layouts).
export default class extends Controller {
  static values = {
    apiKey: String,
    language: { type: String, default: 'fr' }
  };

  connect() {
    if (typeof google !== 'undefined' && google.maps && google.maps.places) {
      this._dispatchReady();
      return;
    }
    if (document.getElementById('google-maps-sdk')) return;

    if (typeof window.initAutocomplete !== 'function') {
      window.initAutocomplete = () => this._dispatchReady();
    }

    const script = document.createElement('script');
    script.id = 'google-maps-sdk';
    script.async = true;
    script.defer = true;
    const params = new URLSearchParams({
      key: this.apiKeyValue,
      libraries: 'places',
      language: this.languageValue,
      callback: 'initAutocomplete'
    });
    script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
    document.head.appendChild(script);
  }

  _dispatchReady() {
    const event = document.createEvent('Events');
    event.initEvent('google-maps-callback', true, true);
    window.dispatchEvent(event);
  }
}
